"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/**
 * @figma designed by Gabe Kelley (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=8943%3A1113))
 * @trackcomponent
 * @lastsynced 2025-07-07T16:19:10.601Z
 * @optimized using svgo:^3.0.2
 */
export const Croatia = createSVGIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 2v12h16V2z"
      fill="#F7FCFF"
    />
    <mask
      id="mask0_8943_1113"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="2"
      width="16"
      height="12"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2v12h16V2z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#mask0_8943_1113)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2v4h16V2z"
        fill="#E31D1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 10v4h16v-4z"
        fill="#3D58DB"
      />
      <path d="M6.039 5.199h5.7v2h-5.7z" fill="#E31D1C" />
      <path
        d="M6.326 6.48h5.065c.008.384.01 1.055.01 1.701q0 .735-.003 1.472v.115q-.03.15-.074.295c-.08.254-.197.496-.346.716-.347.508-.978 1.028-2.153 1.028-1.173 0-1.773-.52-2.093-1.022a2.6 2.6 0 0 1-.369-1.009v-.031l-.002-.098-.004-.354q-.017-1.407-.03-2.813Z"
        fill="#F7FCFF"
        stroke="#E31D1C"
        strokeWidth=".563"
      />
      <mask
        id="mask1_8943_1113"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="6"
        width="6"
        height="7"
      >
        <path
          d="M6.326 6.48h5.065c.008.384.01 1.055.01 1.701q0 .735-.003 1.472v.115q-.03.15-.074.295c-.08.254-.197.496-.346.716-.347.508-.978 1.028-2.153 1.028-1.173 0-1.773-.52-2.093-1.022a2.6 2.6 0 0 1-.369-1.009v-.031l-.002-.098-.004-.354q-.017-1.407-.03-2.813Z"
          fill="#fff"
          stroke="#fff"
          strokeWidth=".563"
        />
      </mask>
      <g mask="url(#mask1_8943_1113)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.249 6.52h1.055v1.071H6.249zm2.11 1.071H7.304v1.071H6.249v1.071h1.055v1.071H6.249v1.071h1.055v-1.071h1.055v1.071h1.055v-1.071h1.054v1.071h1.055v-1.071h-1.055V9.733h1.055V8.662h-1.055V7.591h1.055V6.52h-1.055v1.071H9.413V6.52H8.359zm0 1.071V7.591h1.054v1.071zm0 1.071V8.662H7.304v1.071zm1.055 0v1.071H8.359V9.733zm0 0V8.662h1.054v1.071z"
          fill="#F50100"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.227 6.081s.326-.174.605-.264.497-.139.497-.139l-.414-1.525-.829-.31-.47.774.61 1.465z"
        fill="#56C6F5"
        stroke="#fff"
        strokeWidth=".25"
      />
      <path
        d="m6.09 5.245.095-.046c.099.21.229.276.406.21.182-.068.256-.196.23-.4l.105-.014c.032.253-.07.429-.298.514-.232.087-.417-.006-.538-.264"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m6.317 4.771-.092.055a.027.027 0 0 1-.04-.028l.02-.105-.093-.051a.027.027 0 0 1 .004-.05l.101-.034-.002-.106a.027.027 0 0 1 .045-.021l.08.07.091-.056a.027.027 0 0 1 .04.029l-.02.105.094.051a.027.027 0 0 1-.005.05l-.1.034.002.106a.03.03 0 0 1-.016.025q-.007.004-.015.003a.03.03 0 0 1-.014-.007z"
        fill="#FECA00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.27 5.538s.279-.025.571-.019l.54.008.143-1.506-.627-.564-.696.578.07 1.503Z"
        fill="#56C6F5"
        stroke="#fff"
        strokeWidth=".25"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.875 5.292c.241 0 .264-.26.264-.438-.061-.098-.05-.168-.247-.168s-.22.06-.278.168c0 .178.02.438.26.438m.271-.736c.241 0 .265-.26.265-.438-.062-.098-.05-.169-.247-.169-.198 0-.22.06-.278.17 0 .177.02.437.26.437m-.527 0c.241 0 .264-.26.264-.438-.061-.098-.05-.169-.247-.169s-.22.06-.278.17c0 .177.02.437.26.437"
        fill="#FECA00"
      />
      <path
        d="m7.222 5.803-.036-.123-.433-1.471-.02-.07.05-.053.62-.642.074-.077.087.062.682.484.047.034.005.057.126 1.463.011.13-.13.005h-.013l-.033.002-.117.007q-.15.01-.302.029a3 3 0 0 0-.315.071l-.13.037-.038.012-.01.003-.003.001z"
        fill="#2E42A5"
        stroke="#fff"
        strokeWidth=".25"
      />
      <mask
        id="mask2_8943_1113"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="3"
        width="3"
        height="3"
      >
        <path
          d="m7.222 5.803-.036-.123-.433-1.471-.02-.07.05-.053.62-.642.074-.077.087.062.682.484.047.034.005.057.126 1.463.011.13-.13.005h-.013l-.033.002-.117.007q-.15.01-.302.029a3 3 0 0 0-.315.071l-.13.037-.038.012-.01.003-.003.001z"
          fill="#fff"
          stroke="#fff"
          strokeWidth=".25"
        />
      </mask>
      <g mask="url(#mask2_8943_1113)">
        <path
          d="m7.218 5.319-.125-.295c.269-.118.723-.19 1.201-.218l.019.32c-.445.026-.865.092-1.095.193m-.211-.714-.125-.295c.268-.117.847-.213 1.325-.241l.018.32c-.445.027-.989.115-1.218.216"
          fill="#C51918"
        />
      </g>
      <path
        d="m10.485 5.804.034-.126.397-1.475.018-.066-.046-.05-.584-.64-.075-.082-.09.064-.68.484-.048.034-.005.057-.126 1.463-.011.13.13.005h.013l.033.002.116.007c.094.007.21.016.303.029.088.012.21.042.315.071l.13.037.038.012.01.003.002.001h.001z"
        fill="#2E42A5"
        stroke="#fff"
        strokeWidth=".25"
      />
      <mask
        id="mask3_8943_1113"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="9"
        y="3"
        width="3"
        height="3"
      >
        <path
          d="m10.485 5.804.034-.126.397-1.475.018-.066-.046-.05-.584-.64-.075-.082-.09.064-.68.484-.048.034-.005.057-.126 1.463-.011.13.13.005h.013l.033.002.116.007c.094.007.21.016.303.029.088.012.21.042.315.071l.13.037.038.012.01.003.002.001h.001z"
          fill="#fff"
          stroke="#fff"
          strokeWidth=".25"
        />
      </mask>
      <g mask="url(#mask3_8943_1113)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2 5.234s.146-.082.167-.22c.021-.139.249-.309.135-.288-.114.02-.049.036-.213 0-.165-.036-.378-.06-.378-.161s.106-.182.02-.182c-.087 0-.272-.096-.235-.022.037.073-.085-.01-.024.142s-.013.305.024.345-.024.239-.024.239.023.073.062-.037c.04-.11.125-.187.082-.093-.043.093-.098.316-.049.277a.35.35 0 0 0 .098-.184c0-.037.124-.18.124-.071 0 .107-.117.192-.058.192.058 0 .09.023.127-.085.036-.107.125-.179.161-.107.037.071.029.067-.02.16-.049.095 0 .095 0 .095"
          fill="#FECA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m9.854 4.434-.055-.093q.148-.091.268-.042a.7.7 0 0 1 .133.082l.01.007c.073.051.112.072.136.072v.107c-.055 0-.103-.025-.197-.091l-.008-.006a.7.7 0 0 0-.116-.072q-.065-.03-.171.036m-.173.697a.056.056 0 0 0 .056-.054.056.056 0 0 0-.056-.056.056.056 0 0 0-.057.055c0 .031.025.056.057.056m.161.053c0 .03-.025.054-.056.054a.056.056 0 0 1-.056-.054c0-.032.025-.056.056-.056s.056.024.056.056m.134.05a.056.056 0 0 0 .055-.054.056.056 0 0 0-.077-.052.06.06 0 0 0-.035.051c0 .031.025.055.057.055m.232.034a.056.056 0 0 1-.056.056.056.056 0 0 1-.056-.055c0-.032.024-.056.056-.056.031 0 .056.024.056.055"
          fill="#C51918"
        />
      </g>
      <path
        d="m11.677 6.093-.054.125-.12-.064-.003-.002-.01-.006-.04-.02-.14-.068a4 4 0 0 0-.39-.16 7 7 0 0 0-.451-.127l-.028-.006-.007-.002h-.002l-.13-.03.037-.127.423-1.488.017-.06.06-.023.829-.31.097-.036.053.088.47.774.033.056-.025.06z"
        fill="#56C6F5"
        stroke="#fff"
        strokeWidth=".25"
      />
      <mask
        id="mask4_8943_1113"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="10"
        y="3"
        width="3"
        height="4"
      >
        <path
          d="m11.677 6.093-.054.125-.12-.064-.003-.002-.01-.006-.04-.02-.14-.068a4 4 0 0 0-.39-.16 7 7 0 0 0-.451-.127l-.028-.006-.007-.002h-.002l-.13-.03.037-.127.423-1.488.017-.06.06-.023.829-.31.097-.036.053.088.47.774.033.056-.025.06z"
          fill="#fff"
          stroke="#fff"
          strokeWidth=".25"
        />
      </mask>
      <g mask="url(#mask4_8943_1113)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m11.564 4.545-.071.079a.027.027 0 0 1-.042 0 .03.03 0 0 1-.006-.015l-.01-.106-.104-.022a.03.03 0 0 1-.014-.007.03.03 0 0 1-.006-.03.03.03 0 0 1 .01-.011l.086-.063-.034-.101a.027.027 0 0 1 .038-.034l.097.044.07-.08a.03.03 0 0 1 .03-.007q.007.003.012.009.005.007.006.014l.01.107.105.021c.023.005.03.035.01.048l-.086.063.033.101a.03.03 0 0 1 0 .015.027.027 0 0 1-.037.018z"
          fill="#FECA00"
        />
        <path
          d="m10.498 5.243.106-.414c.47.124.96.283 1.32.437l-.163.395a10 10 0 0 0-1.263-.418"
          fill="#E31D1C"
        />
        <path
          d="m10.642 4.861.025-.104c.45.112.93.29 1.278.457l-.045.096a7 7 0 0 0-1.258-.45zm-.134.427.025-.104c.451.112.868.264 1.216.43l-.045.097a6.4 6.4 0 0 0-1.196-.423"
          fill="#fff"
        />
        <path
          d="m10.711 5.088.097-.044c.04.095.09.116.175.075.198-.096.69.039.69.22 0 .071-.041.114-.104.112a.3.3 0 0 1-.129-.043l-.022-.011a1 1 0 0 0-.082-.04l.035-.102c.023.008.026.01.094.045l.021.01a.3.3 0 0 0 .087.032c.002 0-.006.008-.006-.003 0-.08-.4-.19-.54-.121-.138.067-.252.02-.316-.13"
          fill="#272727"
        />
      </g>
    </g>
    <path stroke="#757575" d="M1 2H17V14H1z" />
  </>,
  "Croatia",
  { fill: "none", viewBox: "0 0 18 16" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
